import { getTermsAndConditionsAgreementStatus } from './api';

/**
 * プライバシーポリシーの利用規約同意状況を取得する関数
 * 
 * @description この関数は、プライバシーポリシーに関する利用規約の同意状況を
 * 非同期で取得し、同意されたバージョン情報を返します。
 * エラーが発生した場合は、エラーログを出力してundefinedを返します。
 * 
 * @returns {Promise<string | undefined>} 利用規約のバージョン文字列、または取得に失敗した場合はundefined
 * 
 * @throws {Error} 利用規約同意状況の取得に失敗した場合（エラーはキャッチされてundefinedが返される）
 * 
 * @example
 * ```typescript
 * const version = await getTermsAndConditionsAgreement();
 * if (version) {
 *   console.log(`同意済みバージョン: ${version}`);
 * } else {
 *   console.log('利用規約の同意状況を取得できませんでした');
 * }
 * ```
 */
export const getTermsAndConditionsAgreement = async (name: string): Promise<string | undefined> => {
    try {
        const result = await getTermsAndConditionsAgreementStatus(name);
        return result?.termsAndConditionsVersion;
    } catch (error) {
        console.error('Error fetching terms and conditions agreement:', error);
        return undefined;
    }
};